// import React, { useState } from "react";
// import toast from "react-hot-toast";

// const ContactSection = () => {
//   const [loading, setLoading] = useState(true);
//   const [formLoading, setFormLoading] = useState(false);
//   const UserContactMessage = (event) => {
//     event.preventDefault();
//     setFormLoading(true); // start loading

//     const ticketUserName = event.target.name.value;
//     const ticketUserEmail = event.target.email.value;
//     const message = event.target.msg.value;
//     const subject = event.target.subject.value;
//     const phone = event.target.phone.value;
//     const ticketStatus = "open";

//     const contact = {
//       ticketUserName,
//       ticketUserEmail,
//       message,
//       subject,
//       phone,
//       ticketStatus,
//       createdAt: new Date(),
//       ticketUserRole: "user",
//     };

//     const url = `https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/new-support-message`;
//     fetch(url, {
//       method: "POST",
//       headers: {
//         "content-type": "application/json",
//       },
//       body: JSON.stringify(contact),
//     })
//       .then((res) => res.json())
//       .then((result) => {
//         event.target.reset();
//         toast.success("Message Sent Successfully!");
//         setFormLoading(false); // stop loading
//       })
//       .catch((error) => {
//         toast.error("Failed to send message. Please try again.");
//         console.error("Error sending message:", error);
//         setFormLoading(false); // stop loading
//       });
//   };

//   return (
//     <>
//       <div class="contact-section-title ptb-100">
//         <div class="container">
//           <div class="row align-items-center">
//             <div class="col-lg-6">
//               <div class="contact-content">
//                 <div class="sub-title-2">
//                   <p>Contact Us</p>
//                 </div>
//                 <h2>Let’s Start Working Together. Get in Touch</h2>
//                 <p>
//                   Get in touch to discuss your employee wellbeing needs today.
//                   Please give us a call, drop us an email.
//                 </p>
//               </div>
//             </div>
//             <div class="col-lg-6">
//               <div class="contact-info">
//                 <div class="row">
//                   <div class="col-lg-6 col-md-6 col-sm-6">
//                     <div class="contact-info-box">
//                       <i class="fi fi-tr-phone-call"></i>
//                       <h4>
//                         <a href="tel:+0123456789102">+012-3456-789102</a>
//                       </h4>
//                       <span>Phone</span>
//                     </div>
//                   </div>
//                   <div class="col-lg-6 col-md-6 col-sm-6">
//                     <div class="contact-info-box">
//                       <i class="fi fi-tr-envelope-dot"></i>
//                       <h4>
//                         <a href="mailto:support@example.com">
//                           support@example.com
//                         </a>
//                       </h4>
//                       <span>Email</span>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="contact-section pb-70">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-6 col-md-6">
//               <div className="contact-form">
//                 <form id="contact-form" onSubmit={UserContactMessage}>
//                   <div className="row">
//                     <div className="col-lg-12 col-md-12">
//                       <div className="form-group">
//                         <input
//                           type="text"
//                           name="ticketUserName"
//                           className="form-control"
//                           id="name"
//                           required=""
//                           data-error="Please enter your name"
//                           placeholder="Your name"
//                         />
//                         <div className="help-block with-errors" />
//                       </div>
//                     </div>
//                     <div className="col-lg-12 col-md-12">
//                       <div className="form-group">
//                         <input
//                           type="email"
//                           name="ticketUserEmail"
//                           className="form-control"
//                           id="email"
//                           required=""
//                           data-error="Please enter your email"
//                           placeholder="Your email address"
//                         />
//                         <div className="help-block with-errors" />
//                       </div>
//                     </div>
//                     <div className="col-lg-12 col-md-12">
//                       <div className="form-group">
//                         <input
//                           type="text"
//                           name="subject"
//                           className="form-control"
//                           required=""
//                           data-error="Please enter your subjects"
//                           placeholder="Your subjects"
//                         />
//                         <div className="help-block with-errors" />
//                       </div>
//                     </div>
//                     <div className="col-lg-12 col-md-12">
//                       <div className="form-group">
//                         <input
//                           type="text"
//                           name="phone"
//                           className="form-control"
//                           id="phone_number"
//                           required=""
//                           data-error="Please enter your phone number"
//                           placeholder="Your phone number"
//                         />
//                         <div className="help-block with-errors" />
//                       </div>
//                     </div>
//                     <div className="col-lg-12 col-md-12">
//                       <div className="form-group">
//                         <textarea
//                           name="message"
//                           id="message"
//                           className="form-control"
//                           cols={30}
//                           rows={6}
//                           required=""
//                           data-error="Please enter your message"
//                           placeholder="Write your message..."
//                           defaultValue={""}
//                         />
//                         <div className="help-block with-errors" />
//                       </div>
//                     </div>
//                     <div className="col-lg-12 col-md-12">
//                       <button
//                         type="submit"
//                         name="submit"
//                         id="submitButton"
//                         className="default-btn"
//                       >
//                         <span>Send Message</span>
//                         <i className="bx bx-paper-plane" />
//                       </button>
//                       <div id="msgSubmit" className="h3 text-center hidden" />
//                       <div className="clearfix" />
//                     </div>
//                   </div>
//                 </form>
//               </div>
//             </div>
//             <div className="col-lg-6 col-md-6">
//               <div className="contact-wrap">
//                 <div className="contact-video-wrap">
//                   <img
//                     src="https://img.freepik.com/free-vector/flat-design-illustration-customer-support_23-2148887720.jpg"
//                     alt="images"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ContactSection;

import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";

const ContactSection = () => {
  const [contactData, setContactData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [formLoading, setFormLoading] = useState(false);

  // Fetch contact data from API
  useEffect(() => {
    const fetchContactData = async () => {
      try {
        const response = await fetch('https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/api/contact-page');
        if (!response.ok) {
          throw new Error('Failed to fetch contact data');
        }
        const result = await response.json();
        setContactData(result.data);
        setIsLoading(false);
      } catch (err) {
        setError(err.message);
        setIsLoading(false);
      }
    };
    fetchContactData();
  }, []);

  const UserContactMessage = (event) => {
    event.preventDefault();
    setFormLoading(true);

    // Fixed: Using correct form field names
    const ticketUserName = event.target.ticketUserName.value;
    const ticketUserEmail = event.target.ticketUserEmail.value;
    const message = event.target.message.value; // Fixed: was 'msg'
    const subject = event.target.subject.value;
    const phone = event.target.phone.value;
    const ticketStatus = "open";

    const contact = {
      ticketUserName,
      ticketUserEmail,
      message,
      subject,
      phone,
      ticketStatus,
      createdAt: new Date(),
      ticketUserRole: "user",
    };

    const url = `https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/new-support-message`;
    fetch(url, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(contact),
    })
      .then((res) => res.json())
      .then((result) => {
        event.target.reset();
        toast.success("Message Sent Successfully!");
        setFormLoading(false);
      })
      .catch((error) => {
        toast.error("Failed to send message. Please try again.");
        console.error("Error sending message:", error);
        setFormLoading(false);
      });
  };

  // Loading state
  if (isLoading) {
    return <div className="text-center py-5">Loading contact information...</div>;
  }

  // Error state
  if (error) {
    return <div className="text-center py-5 text-danger">Error loading contact information: {error}</div>;
  }

  // Empty data state
  if (!contactData) {
    return <div className="text-center py-5">No contact information available.</div>;
  }

  return (
    <>

      <div className="sec-title mb_60 centred mt_50" id="contact-sec">
        <span className="sub-title">{contactData.title}</span>
        <h2>{contactData.subtitle}</h2>
      </div>
      <div className="contact-section pb-70 mt-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <div className="contact-form">
                <form id="contact-form" onSubmit={UserContactMessage}>
                  <div className="row">
                    <div className="col-lg-12 col-md-12">
                      <div className="form-group">
                        <input
                          type="text"
                          name="ticketUserName"
                          className="form-control mt-2"
                          id="name"
                          required
                          data-error="Please enter your name"
                          placeholder="Your name"
                        />
                        <div className="help-block with-errors" />
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-12">
                      <div className="form-group">
                        <input
                          type="email"
                          name="ticketUserEmail"
                          className="form-control mt-2"
                          id="email"
                          required
                          data-error="Please enter your email"
                          placeholder="Your email address"
                        />
                        <div className="help-block with-errors" />
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-12">
                      <div className="form-group">
                        <input
                          type="text"
                          name="subject"
                          className="form-control mt-2"
                          required
                          data-error="Please enter your subjects"
                          placeholder="Your subjects"
                        />
                        <div className="help-block with-errors" />
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-12">
                      <div className="form-group">
                        <input
                          type="text"
                          name="phone"
                          className="form-control mt-2"
                          id="phone_number"
                          required
                          data-error="Please enter your phone number"
                          placeholder="Your phone number"
                        />
                        <div className="help-block with-errors" />
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-12">
                      <div className="form-group">
                        <textarea
                          name="message"
                          id="message"
                          className="form-control mt-2"
                          cols={30}
                          rows={6}
                          required
                          data-error="Please enter your message"
                          placeholder="Write your message..."
                        />
                        <div className="help-block with-errors" />
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-12">
                      <button
                        type="submit"
                        name="submit"
                        id="submitButton"
                        className="theme-btn btn-one mt-3"
                        disabled={formLoading}
                      >
                        <span>{formLoading ? 'Sending...' : 'Send Message'}</span>
                        <i className="bx bx-paper-plane" />
                      </button>
                      <div id="msgSubmit" className="h3 text-center hidden" />
                      <div className="clearfix" />
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="contact-wrap">
                <div className="contact-video-wrap mb-5">
                  <img
                    src={contactData.imageUrl}
                    alt="Contact"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactSection;